import React from 'react'

type Props = {
  partnerId?: string
  allianceId?: string
  SID?: string
  tripSub1?: string
  width?: string | number
  height?: string | number
  className?: string
  style?: React.CSSProperties
}

const TripComWidget: React.FC<Props> = ({
  partnerId = 'S17082746',
  allianceId = '8242207',
  SID = '312434032',
  tripSub1 = '',
  width = '100%',
  height = 222,
  className,
  style,
}) => {
  const src = `https://www.trip.com/partners/ad/${encodeURIComponent(
    partnerId
  )}?Allianceid=${encodeURIComponent(allianceId)}&SID=${encodeURIComponent(
    SID
  )}&trip_sub1=${encodeURIComponent(tripSub1)}`

  const iframeStyle: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    border: '0',
    ...style,
  }

  return (
    <iframe
      id={partnerId}
      title="Trip.com Affiliate Widget"
      src={src}
      style={iframeStyle}
      frameBorder={0}
      scrolling="no"
      className={className}
    />
  )
}

export default TripComWidget
